import React from 'react'

const NewDiscussionForm = () => {
  return <a>foo</a>
}

export default NewDiscussionForm
